<template>
  <div>
    <v-card class="mb-4">
      <v-card-text>
        <v-text-field v-model="form.name"
                      label="What is the name of this template?"
                      placeholder=" "
                      hint="This must be unique."
                      persistent-hint
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('name')">
        </v-text-field>

        <v-text-field v-model="form.subject"
                      label="Subject line"
                      hint="It's best to keep it under 50 characters. You can use tags here."
                      persistent-hint
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('subject')"
                      counter
                      max-length="100">
          <template v-slot:message="{key, message}">
                <span class="mr-1">
                  {{ message }}
                </span>
            <a href="https://coschedule.com/email-subject-line-tester"
               target="_blank">
              Test your subject line
            </a>
          </template>
        </v-text-field>

        <template>
          <div class="my-4">
            <label>
              Email Message Body
            </label>
            <v-alert type="info"
                     dense
                     :icon="false"
                     text
                     tile
                     class="mb-0">
              If you copy text from Microsoft Word, paste it below by pressing <code>CTRL-SHIFT-V</code>. It won't paste correctly if you press <code>CTRL-V</code>.
            </v-alert>
            <tinymce-editor api-key="w7qx9l4xwuc114tjfvqngdobxbi48cjwt782qof3qt0ht031"
                            id="tm3"
                            :init="tinyConfig"
                            v-model="form.html_body">
            </tinymce-editor>

          </div>
        </template>
      </v-card-text>
    </v-card>

    <v-card v-if="1===2"
            class="mb-4">
      <v-card-title>
        Status and Availability
      </v-card-title>
      <v-card-text>
        <v-row class="">
          <v-col cols="12"
                 md="4">
            <v-select v-model="form.status"
                      label="Status"
                      :items="statusCodes"
                      item-value="id"
                      item-text="name">
            </v-select>
          </v-col>
          <v-col cols="12"
                 md="4">
            <v-menu ref="releaseAtMenu"
                    v-model="releaseAtMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    z-index="999">
              <template v-slot:activator="{on, attrs}">
                <v-text-field v-model="form.release_at"
                              label="Release date (Optional)"
                              placeholder="Optional"
                              prepend-icon="fal fa-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                              hint="Leave this blank to make it available now"
                              persistent-hint>
                </v-text-field>
              </template>
              <v-date-picker v-model="form.release_at"
                             no-title
                             scrollable
                             @input="releaseAtMenu = false; expiresAtMenu = true;">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12"
                 md="4">
            <v-menu ref="expiresAtMenu"
                    v-model="expiresAtMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    z-index="999">
              <template v-slot:activator="{on, attrs}">
                <v-text-field v-model="form.expires_at"
                              label="Expires date (Optional)"
                              placeholder="Optional"
                              prepend-icon="fal fa-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable>
                </v-text-field>
              </template>
              <v-date-picker v-model="form.expires_at"
                             no-title
                             scrollable
                             @input="expiresAtMenu = false">
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>

    <v-card v-if="team.campaigns_enabled"
            class="mb-4">
      <v-card-title class="pb-0">
        Settings
      </v-card-title>
      <v-card-text>
        <v-switch v-model="form.is_campaign"
                  label="This template can be used in a campaign"
                  hide-details>
        </v-switch>
      </v-card-text>
    </v-card>

    <content-picker-dialog :form="contentForm"
                           :show="showContentPicker"
                           @close="closeContentPicker"
                           @insert="createLinks">
    </content-picker-dialog>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import formValidation from '../../../plugins/formValidation';
import mobilelockerEditor from '../components/tinymceMobileLocker';
import tinymceService from '../../../../../ml/services/tinymceService';
import dataService from '../../../../../ml/services/dataService';
import ContentPickerDialog from '../../emails/wizard/components/ContentPickerDialog';
import {Form} from "vform";
import sharedLinkService from "../../../../../ml/services/sharedLinkService";

export default {
  components: {ContentPickerDialog},
  mixins: [formValidation],
  props: {
    form: {
      type: Object,
      required: true,
    },
    template: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      contentForm: new Form({ // MLD-3150
        version: 1,
        template_id: '',
        presentations: [],
        subject: '',
        html_body: '',
        include_images: false,
        is_test: false, // MLD-2066
        notification_level: 2,
        recipients: [],
        send_receipt: true, // MLD-2277
      }),
      editor: null,
      expiresAtMenu: false,
      releaseAtMenu: false,
      showContentPicker: false, // MLD-3150
      statusCodes: dataService.statusCodes(),
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    tinyConfig() {
      const config = {
        content_css: `/v2/css/tinymce_editor.css?v=${new Date().getTime()}`, // MLD-2694
        selector: '#tinyEditor',
        height: 700,
        //menubar: 'view insert format tools table help',
        menubar: 'edit view insert format tools help', // @see https://www.tiny.cloud/docs/configure/editor-appearance/#menubar
        menu: { // @see https://www.tiny.cloud/docs/configure/editor-appearance/#menu
          edit: {title: 'Edit', items: 'undo redo | cut copy paste | selectall | searchreplace'},
          view: {title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen'},
          insert: {
            title: 'Insert',
            items: 'link charmap emoticons hr'
          },
          format: {
            title: 'Format',
            items: 'bold italic underline strikethrough superscript subscript | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat'
          },
          tools: {title: 'Tools', items: 'spellchecker spellcheckerlanguage | code wordcount'},
          help: {title: 'Help', items: 'help'}
        },
        quickbars_insert_toolbar: false,
        quickbars_selection_toolbar: 'button_ml_insert_content', // MLD-2693 @see https://www.tiny.cloud/docs/plugins/opensource/quickbars/#quickbars_selection_toolbar
        plugins: 'mobilelockereditor anchor charmap code codesample emoticons fullscreen help hr image link lists media nonbreaking noneditable paste preview quickbars searchreplace table tabfocus template textpattern visualblocks',
        toolbar: 'toggle_button_ml_fullscreen | button_ml_insert_content | menu_button_ml_fragments | undo redo | bold italic underline removeformat | numlist bullist | link',
        style_formats_autohide: true,
        table_toolbar: '', // @see https://www.tiny.cloud/docs/plugins/opensource/table/#table_toolbar
        visual: false, // @see https://www.tiny.cloud/docs/configure/content-appearance/#visual
        contextmenu: 'context_menu_ml_insert_content context_menu_ml_insert_tag',
        init_instance_callback: (editor) => {
          const elm = editor.dom.select('#tinymce')
          editor.dom.addClass(elm, 'EditMode');
          console.log('MemberEmailTemplateForm TinyMCE Editor is now initialized');
        },
        setup: (editor) => {
          this.editor = editor;

          // @see https://www.tiny.cloud/docs/advanced/events/#handlingeditorevents
          editor.on('SetContent', e => { // MLD-3143
            this.selectPlaceholder();
          })

          editor.ui.registry.addToggleButton('toggle_button_ml_fullscreen', {
            text: 'Full screen',
            onAction: (api) => {
              editor.execCommand('mceFullScreen');
              api.setActive(!api.isActive());
            },
          });

          editor.ui.registry.addMenuItem('menuitem_ml_insert_content', {
            icon: 'link',
            text: 'Insert links here',
            tooltip: 'Insert links at your cursor position',
            onSetup: (api) => {
              //if (this.canShareLinks) {
              editor.on('NodeChange', ({element}) => {
                api.setDisabled(!mobilelockerEditor.isEditable(editor, element));
              });
              //}
              //api.setDisabled(!this.canShareLinks);
            },
            onAction: (api) => {
              this.openContentPicker();
            },
          });

          // @see https://www.tiny.cloud/docs/ui-components/contextmenu/
          editor.ui.registry.addContextMenu('context_menu_ml_insert_content', {
            update: (element) => {
              return 'menuitem_ml_insert_content';
            }
          });

          editor.ui.registry.addButton('button_ml_insert_content', { // MLD-2693 @see https://www.tiny.cloud/docs/ui-components/toolbarbuttons/
            //disabled: !this.canShareLinks,
            text: 'Insert links',
            tooltip: 'Insert links at your cursor position',
            onSetup: (api) => {
              editor.on('NodeChange', ({element}) => {
                api.setDisabled(!mobilelockerEditor.isEditable(editor, element));
              });
            },
            onAction: () => {
              this.openContentPicker();
            },
          });

          editor.ui.registry.addMenuButton('menu_button_ml_fragments', { // MLD-2726
            text: 'Insert fragments',
            fetch: (callback) => {
              let items = this.tags.map(tag => {
                return {
                  type: 'menuitem',
                  text: tag.name,
                  onAction: () => {
                    editor.insertContent(tag.tag);
                  }
                }
              });
              callback(items);
            }
          })
        },
      }
      return tinymceService.getConfig(config);
    },
    tags() { // MLD-2726
      const tags = [];
      tags.push({tag: 'Dear {%if recipient.greeting %}{{recipient.greeting}}{% else %}Healthcare Professional{% endif %},', name: `Contact greeting`});
      tags.push({tag: '{{recipient.name}}', name: `Contact full name`})
      tags.push({tag: '{{recipient.first_name}}', name: `Contact first name`});
      tags.push({tag: '{{recipient.last_name}}', name: `Contact last name`});
      tags.push({tag: '{{user_signature}}', name: 'My signature'});
      tags.push({tag: '[INSERT LINKS HERE]', name: 'Links placeholder'});
      return tags;
    },
    useTinyMCE() {
      return true;
    },
  },
  methods: {
    toggleFullScreen() {
      if (this.editor) {
        this.editor.execCommand('mceFullScreen');
      }
    },
    openContentPicker() {
      console.log('openContentPicker()');
      this.showContentPicker = true;
    },
    closeContentPicker() {
      console.log('closeContentPicker()');
      this.showContentPicker = false;
    },
    decorateContent(content) { // MLD-3143
      return content.replaceAll('[INSERT LINKS HERE]', '<span class="ML_insert_links">[INSERT LINKS HERE]</span>');
    },
    selectPlaceholder() { // MLD-3143
      // @see https://stackoverflow.com/a/51514655
      if (this.editor) {
        let selection = this.editor.dom.select(`span.ML_insert_links`);
        if (selection && selection.length) {
          selection = selection[0];
          this.editor.selection.select(selection);
          selection.scrollIntoView({behavior: "instant", block: "center", inline: "nearest"});
          // @see https://www.tiny.cloud/docs/api/tinymce/tinymce.editor/#focus
          this.editor.focus();
        }
      }
    },
    createLinks(includeImages) {
      console.log('createLinks()');
      this.contentForm.include_images = includeImages; // MLD-3113
      this.closeContentPicker();
      const form = {
        expires_at: null,
        is_test: this.contentForm.is_test, // MLD-2066
        notification_level: this.contentForm.notification_level,
        presentation_id: this.contentForm.presentations,
        recipients: [],
        send_now: false,
        send_receipt: false,
        send_reminders: false,
        source: 'compose',
        shared_link_url_parameters: this.previewData ? this.previewData.shared_link_url_parameters : null, // MLD-2954
      };
      sharedLinkService.bulkSharePresentations(form)
        .then(data => {
          this.links = data;
          this.insertLinks(this.links);
          this.contentForm.presentations = [];
        })
        .catch(err => {
          this.$toast.error(`There was a problem creating the links.`, {timeout: 3000});
        })
    },
    insertLinks(links) {
      console.log('insertLinks()');
      const items = [];
      links.forEach(link => {
        if (link.presentation) {
          let linkHTML = link.html.plain;
          if (this.contentForm.include_images) {
            if (link.html.page_thumbnail) {
              linkHTML = link.html.page_thumbnail;
            } else if (link.html.thumbnail) {
              linkHTML = link.html.thumbnail;
            }
          }
          items.push(linkHTML);
        }
      });
      const content = `${items.join('')}`;
      this.insertContent(content);
    },
    insertContent(content, overwrite = false) {
      console.log('insertContent()');
      if (this.useTinyMCE) {
        // @see https://www.tiny.cloud/docs/api/tinymce/root_tinymce/#get
        if (this.editor) {
          if (overwrite) {
            this.editor.setContent(content)
            this.editor.setDirty(true);
          } else {
            // @see https://www.tiny.cloud/docs/api/tinymce/root_tinymce/#execcommand
            if (this.editor.execCommand('insertHTML', false, content)) {
              //console.log('insertHTML worked');
            } else {
              this.$toast.warning('insertHTML failed', {timeout: 3000});
            }
          }
          //this.saveDraft(true);
        } else {
          this.$toast.warning('Could not get the editor', {timeout: 3000});
        }
      } else {
        this.contentForm.html_body = content;
        //this.saveDraft(true);
      }
    },
  }
}
</script>
